export default "__VITE_ASSET__297d268a__"